import * as React from 'react';
import { UIText3 } from '@cian/ui-kit/typography';

import { QuestionLayoutContainer } from '../../containers/QuestionLayoutContainer';

import * as styles from './styles.css';

export interface IFIOQuestionProps {
  title: string;
  fioComponent: React.ReactElement;
  error?: string;
  nextBtnDisabled: boolean;
  handleSubmit(): void;
}

export const FIOQuestion: React.FC<React.PropsWithChildren<IFIOQuestionProps>> = props => {
  const { title, fioComponent, error, nextBtnDisabled, handleSubmit } = props;

  return (
    <QuestionLayoutContainer title={title} disableSubmit={nextBtnDisabled} onSubmit={handleSubmit}>
      <div>{fioComponent}</div>
      {error && (
        <div className={styles['error']} data-testid="error">
          <UIText3 color="error_100">{error}</UIText3>
        </div>
      )}
    </QuestionLayoutContainer>
  );
};

FIOQuestion.displayName = 'FIOQuestion';
